// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("ikart.webshop.shopping_cart");
var shopping_cart = ikart.webshop.shopping_cart;

// Paint the account chip: the visible name AND the avatar initials. Both the
// navbar trigger and the dropdown header carry these hooks, so one call keeps
// them in sync — the server renders "Account" as a placeholder until the real
// business name arrives here.
function imek_set_account_identity(name) {
	name = (name || "").trim();
	if (!name) {
		return;
	}

	// title: the label truncates long business names with an ellipsis
	// (webshop_modern.scss), so the full name is still one hover away.
	$(".imek-account-nav [data-imek-account-label]").text(name).attr("title", name);

	// Up to two initials, skipping punctuation-only tokens so
	// "Kunnil Steel &Metals" gives KS rather than K&.
	var initials = name
		.split(/\s+/)
		.map(function (word) {
			var match = word.match(/[A-Za-z0-9]/);
			return match ? match[0] : "";
		})
		.filter(Boolean)
		.slice(0, 2)
		.join("")
		.toUpperCase();

	$(".imek-account-nav [data-imek-account-avatar]").text(
		initials || name.charAt(0).toUpperCase()
	);
}


function imek_escape_html(value) {
	return String(value ?? "")
		.replace(/&/g, "&amp;")
		.replace(/"/g, "&quot;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");
}

function imek_get_display_name(value) {
	const text = String(value || "").trim();
	if (!text) {
		return "";
	}
	if (!text.includes("@")) {
		return text.replace(/\s+/g, " ").trim();
	}
	const cleaned = text.split("@")[0]
		.replace(/[._-]+/g, " ")
		.replace(/\s+/g, " ")
		.trim();
	return cleaned.split(" ")[0] || cleaned;
}

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user !== "Guest"
		? imek_get_display_name(frappe.session.user_fullname || frappe.session.user)
		: "";
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + imek_escape_html(full_name));
		imek_set_account_identity(full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();
	shopping_cart.set_logged_in_display_name();
});

frappe.ready(() => {
	if (
		ikart.webshop.product_ui
		&& typeof ikart.webshop.product_ui.bind_group_variant_selection === "function"
	) {
		ikart.webshop.product_ui.bind_group_variant_selection();
	}
});

$.extend(shopping_cart, {
	is_cart_request_in_progress: function() {
		return !!shopping_cart._cart_request_in_progress;
	},

	begin_cart_request: function(label, btn) {
		if (shopping_cart.is_cart_request_in_progress()) {
			const $busy_btn = btn ? $(btn) : $();
			if ($busy_btn.length) {
				$busy_btn.prop("disabled", false).removeAttr("aria-busy");
			}
			shopping_cart.show_message(__("Please wait for the current cart update to finish."), "orange");
			return false;
		}

		shopping_cart._cart_request_in_progress = label || "cart";
		shopping_cart.set_cart_controls_busy(true);
		const $btn = btn ? $(btn) : $();
		if ($btn.length) {
			$btn.prop("disabled", true).attr("aria-busy", "true");
		}
		return true;
	},

	end_cart_request: function(btn) {
		shopping_cart._cart_request_in_progress = null;
		shopping_cart.set_cart_controls_busy(false);
		const $btn = btn ? $(btn) : $();
		if ($btn.length) {
			$btn.prop("disabled", false).removeAttr("aria-busy");
		}
		shopping_cart.unfreeze();

		if (shopping_cart._pending_cart_refresh && window.location.pathname === "/cart") {
			shopping_cart._pending_cart_refresh = false;
			if (typeof shopping_cart.refresh_cart_page === "function") {
				shopping_cart.refresh_cart_page();
			}
		}
	},

	set_cart_controls_busy: function(busy) {
		const $controls = $(
			"[data-path='cart'] .cart-qty, " +
			"[data-path='cart'] .imek-qty-btn, " +
			"[data-path='cart'] .remove-cart-item, " +
			"[data-path='cart'] .btn-request-for-quotation, " +
			"[data-path='cart'] .btn-place-order, " +
			"[data-path='cart'] .bt-coupon, " +
			"[data-path='cart'] .bt-remove-coupon-code"
		);

		$controls.each(function() {
			const $control = $(this);
			if (busy) {
				if ($control.data("imek-was-disabled") === undefined) {
					$control.data("imek-was-disabled", $control.prop("disabled"));
				}
				$control.prop("disabled", true).attr("aria-busy", "true");
				return;
			}

			const was_disabled = $control.data("imek-was-disabled");
			$control.prop("disabled", !!was_disabled).removeAttr("aria-busy");
			$control.removeData("imek-was-disabled");
		});
	},

	get_cart_conflict_message: function() {
		return __("Your cart was updated. Please review the latest quantities and try again.");
	},

	is_cart_conflict_response: function(r) {
		const text = JSON.stringify(r || {}).toLowerCase();
		return text.includes("modified after you have opened")
			|| text.includes("timestampmismatch")
			|| text.includes("timestamp mismatch");
	},

	handle_cart_conflict_response: function(message) {
		if (message && message.cart_refreshed && typeof shopping_cart.render_refreshed_cart === "function") {
			shopping_cart.render_refreshed_cart(message);
		} else if (typeof shopping_cart.refresh_cart_page === "function") {
			shopping_cart.refresh_cart_page();
		}
		shopping_cart.show_message(shopping_cart.get_cart_conflict_message(), "orange");
	},

	is_logged_in: function() {
		return frappe.session && frappe.session.user && frappe.session.user !== "Guest";
	},

	get_logged_in_name: function() {
		if (!shopping_cart.is_logged_in()) {
			return "";
		}
		return shopping_cart._logged_in_display_name
			|| imek_get_display_name(frappe.session.user_fullname || frappe.session.user);
	},

	set_logged_in_display_name: function() {
		if (!shopping_cart.is_logged_in()) {
			return;
		}

		frappe.call({
			method: "ikart.webshop.shopping_cart.cart.get_logged_in_user_display_name",
			callback: function(r) {
				const display_name = imek_get_display_name(r.message);
				if (!display_name) {
					return;
				}
				shopping_cart._logged_in_display_name = display_name;
				imek_set_account_identity(display_name);
			}
		});
	},

	show_message: function(message, indicator) {
		if (frappe.show_alert) {
			frappe.show_alert({
				message: message,
				indicator: indicator || "blue"
			});
			return;
		}
		frappe.msgprint(message);
	},

	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").off('shown.bs.dropdown.imekShoppingCartMenu').on('shown.bs.dropdown.imekShoppingCartMenu', function() {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					method: 'ikart.webshop.shopping_cart.cart.get_shopping_cart_menu',
					callback: function(r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	update_cart: function(opts) {
		opts = opts || {};
		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('ikart.webshop.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {
			if (!shopping_cart.begin_cart_request("update", opts.btn)) {
				return $.Deferred().reject({cart_request_locked: true}).promise();
			}
			shopping_cart.freeze();
			const request = frappe.call({
				type: "POST",
				method: "ikart.webshop.shopping_cart.cart.update_cart",
				args: {
					item_code: opts.item_code,
					qty: opts.qty,
					selected_uom: opts.selected_uom || "",
					additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
					with_items: opts.with_items || 0
				},
				btn: opts.btn,
				callback: function(r) {
					shopping_cart.invalidate_cart_dropdown();
					if (!r.exc && r.message && r.message.cart_refreshed) {
						shopping_cart.handle_cart_conflict_response(r.message);
						return;
					}
					shopping_cart.set_cart_count(true, r.message && r.message.cart_count);
					if(opts.callback)
						opts.callback(r);
				},
				error: function(r) {
					if (shopping_cart.is_cart_conflict_response(r)) {
						shopping_cart.handle_cart_conflict_response();
						return;
					}
					if (window.location.pathname === "/cart") {
						var msg = "";
						if (r && r.responseJSON && r.responseJSON._server_messages) {
							msg = JSON.parse(r.responseJSON._server_messages || []).join("<br>");
						}
						$("#cart-error").empty().html(msg || __("Something went wrong!")).toggle(true);
					}
				},
			});
			request.always(function() {
				shopping_cart.end_cart_request(opts.btn);
			});
			return request;
		}
	},

	invalidate_cart_dropdown: function() {
		$('.shopping-cart-menu').empty();
		if ($('.shopping-cart-menu:visible').length) {
			frappe.call({
				method: 'ikart.webshop.shopping_cart.cart.get_shopping_cart_menu',
				callback: function(r) {
					if (r.message) {
						$('.shopping-cart-menu').html(r.message);
					}
				}
			});
		}
	},

	// True when this page's cart is the marketplace (localStorage) enquiry cart
	// rather than the B2B webshop Quotation cart. The server marks the cart nav
	// item with data-imek-cart-mode="marketplace" (see navbar_items.html /
	// use_webshop_cart()). In that mode marketplace_cart.js owns the cart
	// badges and the floating pill.
	is_marketplace_cart_mode: function() {
		return $("[data-imek-cart-mode='marketplace']").length > 0;
	},

	get_dom_cart_count: function() {
		let count = 0;
		$(".cart-container .cart-items tr").each(function() {
			const qty = Number.parseFloat($(this).find(".cart-qty").first().val());
			count += Number.isFinite(qty) && qty > 0 ? qty : 1;
		});
		return count;
	},

	has_cart_items: function() {
		return shopping_cart.get_dom_cart_count() > 0;
	},

	clear_submitted_cart_state: function() {
		if (window.localStorage) {
			localStorage.setItem("cart_count", "0");
			localStorage.setItem("imek_cart_count", "0");
		}
		shopping_cart.set_cart_count(false, 0);
	},

	set_cart_count: function(animate=false, cart_count_override) {
		$(".intermediate-empty-cart").remove();

		var cart_count = cart_count_override;
		if (cart_count === undefined || cart_count === null) {
			cart_count = frappe.get_cookie("cart_count");

			// No readable cookie does NOT mean an empty cart. navbar_items.html
			// now renders the real count into the badge's data-count, so trust
			// that before concluding zero.
			//
			// Without this the page fought itself: the server rendered the cart
			// entry visible, then this ran, read no cookie, fell through to
			// get_dom_cart_count() — which only sees rows on /cart and so returns
			// 0 everywhere else — and hid the entry again. That is why the mobile
			// bottom-nav cart appeared only sometimes.
			if (cart_count === undefined || cart_count === null || cart_count === "") {
				var $server_count = $("[data-imek-cart-count]").first();
				if ($server_count.length) {
					var server_rendered = parseInt($server_count.attr("data-count"), 10);
					if (Number.isFinite(server_rendered)) {
						cart_count = server_rendered;
					}
				}
			}

			// The /cart page's server-rendered empty state is the source of truth.
			// The `cart_count` cookie goes stale (a submit that errored, a cart
			// emptied in another tab), and trusting it here resurrected the
			// floating cart pill on a visibly empty cart — an empty cart is a
			// dead end, so the pill must stay hidden. Only applies to the cookie
			// fallback; an explicit override always wins.
			var $cart_empty = $(".cart-empty");
			if ($cart_empty.length && !$cart_empty.hasClass("hidden")) {
				cart_count = 0;
			}
		}
		if(frappe.session.user==="Guest") {
			cart_count = 0;
		}
		if (window.localStorage) {
			localStorage.setItem("cart_count", cart_count || "0");
			localStorage.setItem("imek_cart_count", cart_count || "0");
		}

		$(".shopping-cart").toggleClass('hidden', false);

		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");
		var $mobile_cart = $(".imek-mobile-bottom-cart");
		var $mobile_badge = $mobile_cart.find("[data-imek-cart-count]");
		var server_count = parseInt(cart_count || 0);
		if (!server_count && shopping_cart.has_cart_items()) {
			server_count = shopping_cart.get_dom_cart_count();
		}
		var count = server_count;

		// Cart entry points only exist once the cart has something in it — an
		// empty cart is a dead end. Both ship hidden (the <li> from the server in
		// navbar_items.html) and is revealed here.
		//
		// ONLY when this page uses the webshop cart. On marketplace pages the
		// cart lives in localStorage and `count` here is always 0 (it reads the
		// webshop cart_count cookie, forced to 0 for Guests) — so toggling from
		// this number would permanently hide the marketplace user's cart.
		// marketplace_cart.js syncBadge() owns these elements in that mode.
		if (!shopping_cart.is_marketplace_cart_mode()) {
			var has_items = count > 0;
			$("[data-imek-cart-item]").toggleClass("hidden", !has_items);
		}

		if(count === 0) {
			$cart.css("display", "");
			$badge.text("").addClass("hidden");
			$mobile_badge.text("").attr("data-count", "0").addClass("hidden");
			$(".cart-tax-items").hide();
			$(".btn-place-order").hide();
			$(".cart-payment-addresses").hide();

			let intermediate_empty_cart_msg = `
				<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
					${ __("Cart is Empty") }
				</div>
			`;
			$(".cart-table").after(intermediate_empty_cart_msg);
		}
		else {
			$cart.css("display", "");
			$badge.text(count).removeClass("hidden");
			$mobile_badge.text(count).attr("data-count", count).removeClass("hidden");
		}

		if(count > 0) {
			if (animate) {
				$cart.addClass("cart-animate");
				$mobile_cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
					$mobile_cart.removeClass("cart-animate");
				}, 500);
			}
		}
	},

	shopping_cart_update: function({item_code, qty, cart_dropdown, additional_notes, selected_uom, btn}) {
		return shopping_cart.update_cart({
			item_code,
			qty,
			selected_uom,
			additional_notes,
			with_items: 1,
			btn: btn || this,
			callback: function(r) {
				if(!r.exc && r.message && r.message.cart_refreshed) {
					shopping_cart.render_refreshed_cart(r.message);
				} else if(!r.exc) {
					// On the /cart page, re-render through the split-aware
					// endpoint so the "Quote Items" / "Enquiry Items" sections
					// stay separated (a flat .cart-items fill would merge them).
					if (window.location.pathname === "/cart"
						&& typeof shopping_cart.refresh_cart_page === "function") {
						shopping_cart.refresh_cart_page();
					} else {
						$(".cart-items").html(r.message.items);
						$(".cart-tax-items").html(r.message.total);
						$(".payment-summary").html(r.message.taxes_and_totals);
					}
					shopping_cart.set_cart_count(false, r.message.cart_count);

					if (cart_dropdown != true) {
						$(".cart-icon").hide();
					}
				}
			},
		});
	},

	show_cart_navbar: function () {
		const cache_key = "imek_cart_enabled";
		const cache_ttl = 300000;
		const apply_cart_visibility = (enabled) => {
			$(".shopping-cart").toggleClass('hidden', !enabled);
			$(".imek-mobile-bottom-cart")
				.closest(".imek-bottom-nav__item")
				.toggleClass("hidden", !enabled);
		};

		if (window.localStorage) {
			try {
				const cached = JSON.parse(localStorage.getItem(cache_key) || "null");
				if (cached && cached.expires > Date.now()) {
					apply_cart_visibility(!!cached.enabled);
					return;
				}
			} catch (e) {
				localStorage.removeItem(cache_key);
			}
		}

		frappe.call({
			method: "ikart.webshop.doctype.webshop_settings.webshop_settings.is_cart_enabled",
			callback: function(r) {
				const enabled = !!r.message;
				if (window.localStorage) {
					try {
						localStorage.setItem(cache_key, JSON.stringify({
							enabled: enabled,
							expires: Date.now() + cache_ttl
						}));
					} catch (e) {
						localStorage.removeItem(cache_key);
					}
				}
				apply_cart_visibility(enabled);
			}
		});
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	get_selected_qty($btn) {
		const $container = $btn.closest('.cart-action-container');
		const $qty_input = $container.find('.product-qty-input').first();
		let qty = Number.parseFloat($qty_input.val());

		if (!Number.isFinite(qty) || qty <= 0) {
			qty = 1;
		}

		// NEVER write the resolved qty back into the field. The qty box stays
		// blank (placeholder "1") so the next entry can be typed directly —
		// writing "1" here forced users to clear it before typing e.g. 6.

		return qty;
	},

	get_selected_uom($btn) {
		const $container = $btn.closest('.cart-action-container');
		const $select = $container.find('.product-uom-select').first();
		if ($select.length) {
			return $select.val() || "";
		}
		const $scope = $btn.closest('.item-card, .list-row, .product-container, .item-cart');
		const $price = $scope.find('.product-price').first();
		const source = $price.data() || {};
		return source.useAlternateOrderUom ? (source.orderUom || "") : "";
	},

	// The UOM to SHOW in the popup. get_selected_uom() returns "" when the item
	// is ordered in its stock UOM (nothing to override on the request), but the
	// popup should still tell the customer what they are counting in.
	get_display_uom($btn) {
		const $scope = $btn.closest('.item-card, .list-row, .product-container, .item-cart');
		const source = $scope.find('.product-price').first().data() || {};
		return source.orderUom || "";
	},

	bind_add_to_cart_action() {
		if (shopping_cart.add_to_cart_action_bound) {
			return;
		}
		shopping_cart.add_to_cart_action_bound = true;

		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);
			if ($btn.hasClass('go-to-cart') || $btn.hasClass('go-to-cart-grid')) {
				return;
			}

			e.preventDefault();
			$btn.prop('disabled', true);

			if (frappe.session.user==="Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('ikart.webshop.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			const $container = $btn.closest('.cart-action-container');
			const selected_uom = shopping_cart.get_selected_uom($btn);
			const $scope = $btn.closest('.item-card, .list-row');

			// Listing cards have no inline qty box any more — the cart button
			// asks for the quantity in a popup. Anywhere that still ships one
			// (the item page, the cart) keeps working unchanged: if a qty field
			// is present in scope we read it and add straight away.
			const has_inline_qty = $container.find('.product-qty-input').length > 0;
			if (!has_inline_qty && ikart.webshop.product_ui.open_add_to_cart_popup) {
				$btn.prop('disabled', false);
				ikart.webshop.product_ui.open_add_to_cart_popup({
					// the card itself: the popup reads title, options and price
					// from it and forwards option clicks back into it
					$scope,
					add_label: $btn.attr('aria-label') || __("Add to Cart"),
					on_confirm: (chosen_qty) => {
						// re-read the uom AFTER the popup, since choosing a
						// different size in there can change it
						shopping_cart.add_to_cart_from_button(
							$btn, chosen_qty, shopping_cart.get_selected_uom($btn)
						);
					}
				});
				return;
			}

			shopping_cart.add_to_cart_from_button(
				$btn, shopping_cart.get_selected_qty($btn), selected_uom
			);
		});
	},

	// The actual add. Shared by both entry points -- the inline qty field where
	// one still exists (item page, cart) and the popup the listing cards now
	// open -- so the optimistic "Go to Cart" swap and its rollback behave
	// identically either way.
	add_to_cart_from_button($btn, qty, selected_uom) {
		const $container = $btn.closest('.cart-action-container');
		const $scope = $btn.closest('.item-card, .list-row');
		const $active_variant = $scope.find('.product-size-option.active').first();
		const indicator_source = $active_variant.length
			? $active_variant.data()
			: $scope.find('.product-price').first().data();
		const indicator_text = ikart.webshop.product_ui.get_cart_indicator_text(
			qty,
			indicator_source && indicator_source.orderUom,
			indicator_source && indicator_source.useAlternateOrderUom
		);

		$btn.prop('disabled', true).addClass('hidden');
		$container.addClass('d-flex');
		$container.find('.product-qty-wrapper').addClass('hidden');
		$container.find('.go-to-cart').removeClass('hidden');
		$container.find('.go-to-cart-grid').removeClass('hidden');
		$container.find('.cart-indicator').text(indicator_text).removeClass('hidden');

		const item_code = $btn.data('item-code');
		const restore_add_button = () => {
			$btn.prop('disabled', false).removeClass('hidden');
			$container.find('.product-qty-wrapper').removeClass('hidden');
			$container.find('.go-to-cart, .go-to-cart-grid, .cart-indicator').addClass('hidden');
		};
		const request = ikart.webshop.shopping_cart.update_cart({
			item_code,
			qty,
			selected_uom,
			btn: $btn,
			callback(r) {
				$btn.prop('disabled', false);
				if (r.exc) {
					restore_add_button();
				} else if ($active_variant.length) {
					$active_variant
						.attr('data-in-cart', 1)
						.attr('data-cart-qty', qty)
						.data('in-cart', 1)
						.data('cart-qty', qty);
				}
			}
		});
		if (request && request.fail) {
			request.fail(restore_add_button);
		}
	},

	freeze() {
		if (window.location.pathname !== "/cart") return;

		if (!$('#freeze').length) {
			let freeze = $('<div id="freeze" class="modal-backdrop fade"></div>')
				.appendTo("body");

			setTimeout(function() {
				freeze.addClass("show");
			}, 1);
		} else {
			$("#freeze").addClass("show");
		}
	},

	unfreeze() {
		if ($('#freeze').length) {
			let freeze = $('#freeze').removeClass("show");
			setTimeout(function() {
				freeze.remove();
			}, 1);
		}
	}
});
